const Projectlisting = [
    {
        id: 1,
        pics: [
            "/condo2.jpg",
            "/condo1.jpg",
            "/condo3.jpg",
            "/condo4.jpg",
            "/condo6.jpg",






        ],
        Residence: "IMPERIALE  RESIDENCE",
        Area: "-",
        Logo: "/IMPERIAL.png",
        Price: "+",
        Features1: " 30 STOREY CONDOMINIUM",
        Address: "CBD, Abuja",
        Features2: "30 STOREY CONDOMINIUM. ARCHITECTURE:Water Fountain, 2-Rooftop Heli-Pads, Over 100 SuperLuxury Condos, Tallest Residential & , Mix-Use Building in Abuja with 30-Storeys. SECURITY: Automatic Vehicle , Barrier System, 50+ Advanced Cctv , Cameras On-Site, Card-Enabled Access , Control For All Area. Services:ATM, Restaurants, Facility Room, Business Center, Hair & Beauty Salon, Laundry / Dry , Cleaning, Fast-Fibre Internet, Services, Fully Serviced Facility , Office, Meeting & Conference , Rooms, 24-hour Concierge and  Maintenance Services. INTERIORS:Fire Alarm, Smoke Detectors, Integrated Wardrobes, Fully Marbled, Flooring, Landscaped, Surroundings, Automated Water , Sprinklers, Daikin VRV AirConditioning, High-Speed Schindler, Elevators, Smart Lighting , Control System, Top-Range Miele , Kitchen Appliances, Sound-Insulating &, Shatter-Proof Glas. AMENITIES:Play Garden, Imax Cinema, Fitness Centre, Indoor Infiniti Pool, Indoor Sporting Facilities, Luxurious Spa, Steam & , Sauna Facilities, Residents-Only 5-Star , Restaurant & Lounge, High Speed Residential & Service Elevators, Games Room (Pool , Table, Arcade, Table , Football, Table Tennis), Luxurious Grand , Interactive 3-Floor World , Class Lobby with an Aquarium Shatter-Proof Glass",
        Features3: " ",
        Place: "CBD"

    },



    
    {
        id: 2,
        pics: ["/imperial1.jpg",
            "/imperial2.jpg",
            "/imperial3.jpg",
            "/imperial4.jpg",
            "/imperial5.jpg",
            "/imperial6.jpg",
            "/imperial7.jpg",
            "/imperial8.jpg",
            "/imperial9.jpg",
            "/imperial10.jpg",
            "/imperial11.jpg",
        ],
        Residence: "IMPERIALE HOTEL",
        Area: "-m",
        Logo: "/Bahamas.png",
        Price: "N",
        Features1: " ",
        Address: "CBD , Abuja ",
        Features2: "Imperial condo residenetial complex ",
        Features3: "24+ floors condomonium ",
        Place: "CBD"

    },



    
    {
        id: 3,
        pics: ["/E2.jpg",
            "/E3.jpg",
            "/E8.jpg",
            "/E10.jpg",
            "/E11.jpg",
            "/E12.jpg",
            
        ],
        Residence: "THE MARIANA",
        Area: "500m",
        Logo: "/MARIANA.png",
        Price: "N450M",
        Features1: " 11 units of 4 Bedroom Detached Duplex. ",
        Address: " Idu, Abuja",
        Features2: "  Commercial complex and Residence area, 11 units of detached,  7 units of 4-bedroom Duplex, 11 units of 5-bedroom Duplex, 7 units of 3-bedroom duplex.De Mariana provide a wealth of secluded places if you long for a tranquil living away from the busy city. Imagine waking up to the soothing sound of birds chirping and enjoying your morning coffee on a warm terrace surrounded by luscious vegetation. For families looking for a balance between serenity and accessibility to urban attractions, suburban homes with roomy yards, outstanding school districts, and a sense of community",
        Features3: " 7 units of 4",
        Place: "Life Camp"

    },








    {
        id: 4,
        pics: ["/Cayman1a.jpg",

            "/Cayman1b.jpg",
            "/Cayman1c.jpg",
            "/Cayman1d.jpg",
            "/Cayman1e.jpg",

        ],
        Residence: "CAYMAN 1 RESIDENCE",
        Area: " 1,500 m",
        Logo: "/CAYMAN.png",
        Price: "N700M",
        Features1: " 2 units of fully detached mansion",
        Address: "Maitama, Abuja",
        Features2: "Cayman Residence offers an exceptional living experience for people who live on the vibrancy of city life. Elegant high-rise apartments, hip lofts, or stylish townhouses tucked away in the centre of the city offer quick access to popular nightlife spots and a wide range of entertainment options. Enjoy the convenience of having top-notch restaurants, stores, and cultural organizations just outside your door",
        Features3: " 2 units of 6 ",
        Place: "Maitama"

    },



    {
        id: 5,
        pics: ["/CAY1.jpg",
            "/CAY2.jpg",
            "/CAY3.jpg",
            "/CAY4.jpg",
            "/CAY5.jpg",
            "/CAY6.jpg",

        ],
        Residence: "CAYMAN 2 RESIDENCE",
        Area: "1,500m",
        Logo: "/CAYMAN.png",
        Price: "N600M",
        Features1: " 4 units of 6 bedroom fully detached duplex ",
        Address: "Maitama, Abuja",
        Features2: "Amazing views of Maitama, 2 units of 6 bedroom detached Duplex, Pent-House: Ensuit Study, Entertainment Pad, boys quarters",
        Features3: " 4 units of 6 ",
        Place: "Maitama"

    },




    {
        id: 6,
        pics: ["/AS1.jpg",
            "/AS2.jpg",
            "/AS3.jpg",
            "/AS4.jpg",
            "/AS5.jpg",
            "/AS6.jpg",

        ],
        Residence: "HAYMAN RESIDENCE",
        Area: "-m",
        Logo: "/HAYMAN.png",
        Price: "N600M",
        Features1: " 4 units of 4 Bedroom Detached Duplex. ",
        Address: "Asokoro, Abuja",
        Features2: "Amazing views of Asokoro Hills, Basement:   Lobby, Store Room, 2 Car's park, Maids room, Laundry room, Gfl: Lobby, Ante Room, Living Room, Dinning Room, Powder room, Kitchen w/Pantry , Ensuite Guest Bedroom, Ffl: Lobby, Family Lounge w/Balcony, Two bedrooms Ensuite, Master's Bed room w/Walk-in-closet. Pent-House:Multi-Purpose. Hayman Residence offer the best features and facilities available. These homes can include large living areas with high ceilings, numerous bedrooms and baths, cutting-edge kitchens, and private home theaters, to name just a few amenities. In order to ensure that occupants can enjoy the wonders of nature and the pleasures of outdoor life, luxury homes frequently feature extraordinary outdoor spaces, such as perfectly maintained gardens, infinity pools, outdoor kitchens, and private tennis courts or golf courses. In addition, Hayman Residence f offers a wide range of first-rate services and amenities to meet the demands and preferences of its occupants. This estate provides a lifestyle that exceeds expectations, from 24-hour concierge services and private security to exclusive access to fitness centers, spas, and private clubs in the area. Hayman frequently have features that enhance comfort and convenience, such as smart home automation systems, dedicated staff quarters, private wine cellars, home gyms, and mor",
        Features3: " 4 units of 4 ",
        Place: "Asokoro"

    },

    {
        id: 7,
        pics: ["/Marshallres3b.png",
            "/Marshallres2b.jpeg",
            "/Marshallres4b.png",
       
        ],
        Residence: "MARSHALL RESIDENCE",
        Area: "250Sqm-400sqm ",
        Logo: "/MARSHAL.png",
        Price: "N2.850M-4.95M",
        Features1: " 2 units of 5 Bedroom Detached Duplex. ",
        Address: "Gwagwalada, Abuja",
        Features2: " 2 bedroom duplex 250sqm,   3bedroom duplex 300sqm and   4 bedroom duplex 400sqm."+
        "Amenities:Eatery, Car Wash, Mini-Mart, Electricity, Pharmacy Street Light, Clean Water, 24/7 Security, Commercial Complex, Quality Road & Drainage, Fruit & Vegetable Market ",
        Features3: " 2-4 bedroom ",
        Place: "Gwagwalada"

    },


    {
        id: 8,
        pics: ["/Bali1.jpg",
            "/Bali2.jpg",
            "/Bali3.jpg",
            "/Bali4.jpg",
            "/Bali5.jpg",


        ],
        Residence: "BALI RESIDENCE",
        Area: "5000m",
        Logo: "/BALI1.png ",
        Price: "N430M",
        Features1: " 10 units of 4 Bedroom duplex. ",
        Address: " Guzape, Abuja",
        Features2: "Bali residences offer an evident draw if your heart yearns for the calming sound of crashing traverse and breath-taking views. Bali living enables you to indulge in a leisurely lifestyle and enjoy outdoor activities like swimming and sunbathing. It offers gorgeous estates as well as commercial complexes nestled away near the estate. Experience the tranquillity of living by the peaceful estate as you immerse yourself in the enchanting beauty of the estate ",
        Features3: " 10 units of 4 ",
        Place: "Guzape"

    },


   
    {
        id: 9,
        pics: [
            "/Sardinal2.jpg",
            "/Sardinal3.jpg",
            "/Sardinal4.jpg",
            "/Sardinal1.jpg",

        ],
        Residence: "SARDINIA RESIDENCE",
        Area: "-m",
        Logo: "/SARDINAL.png",
        Price: "N75M",
        Features1: "Commercial Complex and Residential ",
        Address: " Life Camp, FCDA Mass Housing, Abuja ",
        Features2: "Residences and buildings in Sardinia are recognized for their unique architectural designs that masterfully meld creativity, beauty, and efficiency. The artistic brilliance of well-known architects and interior designers is frequently on display in these architectural wonders. Magnificent mansions show incomparable grandeur and timeless grace, for instance. These enormous mansions have exquisite craftsmanship, large gardens, and a plethora of opulent facilities including private swimming pools, home theatres, wine cellars, and cutting-edge security systems. ",
        Features3: " 3 ",
        Place: "Life Camp"

    },


    {
        id: 9,
        pics: ["/Palawa1.png",
            "/Palawa2.png",
            "/Palawa3.png",




        ],
        Residence: "PALAWA RESIDENCE",
        Area: "150-500m",
        Logo: "/Palawa.png",
        Price: "N18",
        Features1: " ",
        Address: "F01 Kubwa , Abuja ",
        Features2: " 1 bed room duplex 150 sqm, 2 bed room duplex 250 sqm, 3 bed room duplex 350sqm ,4 bed room duplex 400sqm, 5 bed room duplex 500 sqm",
        Features3: " ",
        Place: "Kubwa"

    },

   



]


export default Projectlisting;